import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../store/app.state";
import { GetNewsByIdAction } from "../../../../store/news/actions";
import { OAuthService } from "../../../../authentication/auth.service";
import { INews, PartType } from "src/app/models/news.model";
import { NewsService } from "src/app/services/news.service";
import { AttachmentModel } from "src/app/models/document.model";

@Component({
  selector: "app-news-detail",
  templateUrl: "./news-detail.component.html",
  styleUrls: ["./news-detail.component.scss"],
})
export class NewsDetailComponent implements OnInit, OnDestroy {
  private newsSubscription: Subscription;

  oneNews: INews;
  slug: string = "";
  imageUrl: string = "";
  thumbnailImageUrl: string = "";
  markdownContent: string = "";
  attachments: AttachmentModel[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    protected store: Store<AppState>,
    private newsService: NewsService,
    private userService: OAuthService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.slug = params["id"];
      const published =
        this.route.snapshot.queryParamMap.get("published") === "true";
      this.store.dispatch(new GetNewsByIdAction(this.slug, published));
    });

    this.newsSubscription = this.store
      .select((state) => state.news)
      .subscribe(async (result) => {
        if (result && result.getLoading === false && result.detailNews) {
          this.oneNews = result.detailNews;

          this.thumbnailImageUrl =
            this.newsService.getThumbnailImage(this.oneNews.parts)
              ?.previewUrl || null;
          this.markdownContent = await this.newsService.parseMarkdownContent(
            this.oneNews.parts,
          );

          this.attachments =
            this.newsService.getAttachments(this.oneNews.parts) || [];
        }
      });
  }

  loadFile(item) {
    fetch(item.downloadUrl, {
      headers: new Headers({
        Origin: location.origin,
      }),
      mode: "cors",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const a = document.createElement("a");
        a.download = item.originalFileName;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      })
      .catch((e) => console.error(e));
  }

  backClick() {
    const prevUrl = this.userService.getPreviousUrl();
    prevUrl.indexOf("detail") !== -1
      ? this.router.navigate([`/news`])
      : this.router.navigate([prevUrl]);
  }

  getColumns(row) {
    const result = [];
    if (row === undefined) return result;

    const allKeys = Object.keys(row);
    for (const index in allKeys) {
      result.push(allKeys[index]);
    }

    return result;
  }

  getRowValues(row) {
    const result = [];

    const allKeys = Object.keys(row);
    for (const index in allKeys) {
      result.push(row[allKeys[index]]);
    }

    return result;
  }

  ngOnDestroy(): void {
    if (this.newsSubscription) {
      this.newsSubscription.unsubscribe();
    }
  }
}
